import i18n from "@/libs/i18n"

export default [
    {
        path: "/companies",
        name: "list-companies",
        component: () =>
            import("@/views/app/companies/companies-list/CompaniesList.vue"),
        meta: {
            i18nTitle: {
                tc: "modules.companies.description",
                index: 2,
            },
            pageTitle: i18n.tc("modules.companies.description", 2),
            breadcrumb: [
                {
                    i18nText: {
                        tc: "modules.companies.description",
                        index: 2,
                    },
                    active: true,
                },
            ],
            action: "list",
            resource: "companies",
        },
    },
    {
        path: "/companies/:id",
        name: "view-companies",
        component: () =>
            import("@/views/app/companies/companies-view/CompaniesView.vue"),
        meta: {
            i18nTitle: {
                tc: "modules.companies.description",
                index: 1,
            },
            pageTitle: i18n.tc("modules.companies.description", 1),
            breadcrumb: [
                {
                    i18nText: {
                        tc: "modules.companies.description",
                        index: 2,
                    },
                    to: { name: "list-companies" },
                },
                {
                    i18nText: {
                        tc: "modules.companies.description",
                        index: 1,
                    },
                    active: true,
                },
            ],
            action: "view",
            resource: "companies",
        },
    },
    {
        path: "/companies/:id/edit",
        name: "edit-companies",
        component: () =>
            import("@/views/app/companies/companies-edit/CompaniesEdit.vue"),
        meta: {
            i18nTitle: {
                t: "modules.companies.details",
            },
            pageTitle: i18n.t("modules.companies.details"),
            breadcrumb: [
                {
                    i18nText: {
                        tc: "modules.companies.description",
                        index: 2,
                    },
                    to: { name: "list-companies" },
                },
                {
                    i18nText: {
                        tc: "modules.companies.description",
                        index: 1,
                    },
                    to: { name: "view-companies" },
                },
                {
                    i18nText: {
                        t: "modules.companies.details",
                    },
                    active: true,
                },
            ],
            action: "edit",
            resource: "companies",
        },
    },
]
